<app-hero-image></app-hero-image>

<app-tiles-info></app-tiles-info>

<app-how-it-works></app-how-it-works>

<app-partner-list
    titleKey="past-winning-providers-title"
    cmsKey="past-winning-providers-logo"
></app-partner-list>

<app-testimonials></app-testimonials>

<section class="fluid-container">
    <div class="container py-0 pt-md-5">
        <div class="row align-items-center justify-content-around pb-5">
            <div class="col-md-6 mr-0 mr-md-3 mb-3 mb-md-0">
                <div
                    youtubemovie="n7u-Tr-S2LA"
                    class="ratio ratio-16x9 embed-responsive rounded mb-3 mb-md-0 shadow-sm"
                ></div>
            </div>
            <div class="col-md-6">
                <div
                    youtubemovie="0fZWZrq4UTw"
                    class="ratio ratio-16x9 embed-responsive rounded mb-3 mb-md-0 shadow-sm"
                ></div>
            </div>
        </div>
    </div>
</section>

<app-partner-list
    titleKey="past-winning-supplier-title"
    cmsKey="past-winning-supplier-logo"
    [showEnvironmentTexasLogo]="true"
></app-partner-list>

<app-info-register></app-info-register>
